export enum GraficaEnum {
  TRANSPORTE = 0,
  EXTENDIDO = 1
}
